import { __assign, __read } from "tslib";
import { isCity, isMoney, isBaseData, isDepartments } from '@ekuaibao/lib/lib/propertySetIs';
import moment from 'moment';
import { FieldType } from './types';
import { availableBaseFields } from './config';
var isDate = function (property) {
    var _a;
    return ((_a = property.dataType) === null || _a === void 0 ? void 0 : _a.type) === FieldType.Date;
};
var isText = function (property) {
    var _a;
    return ((_a = property.dataType) === null || _a === void 0 ? void 0 : _a.type) === FieldType.Text;
};
var isList = function (property) {
    var _a;
    return ((_a = property.dataType) === null || _a === void 0 ? void 0 : _a.type) === FieldType.List;
};
export var extractFieldInfo = function (fieldId, dataSource) {
    var template = dataSource.template, value = dataSource.value;
    var propertyItem = template[fieldId];
    var valueItem = value[fieldId];
    if (!propertyItem) {
        return {
            label: '',
            enLabel: '',
            value: '',
            enValue: '',
        };
    }
    var labelInfo = {
        label: propertyItem.label,
        enLabel: propertyItem.enLabel,
    };
    if (!valueItem) {
        return __assign(__assign({}, labelInfo), { value: '', enValue: '' });
    }
    if (isBaseData(propertyItem)) {
        return __assign(__assign({}, labelInfo), { value: valueItem.name || '', enValue: valueItem.enName || '' });
    }
    else if (isDepartments(propertyItem)) {
        var deps = Object.values(valueItem);
        return __assign(__assign({}, labelInfo), { value: deps.map(function (item) { return item; }).join(',') || '', enValue: '' });
    }
    else if (isCity(propertyItem)) {
        return __assign(__assign({}, labelInfo), { value: valueItem
                .map(function (item) { return item.name; })
                .join('、') || '', enValue: valueItem
                .map(function (item) { return item.enName; })
                .join('、') || '' });
    }
    else if (isMoney(propertyItem)) {
        var standardSymbol = valueItem.standardSymbol, standardUnit = valueItem.standardUnit, standard = valueItem.standard;
        return __assign(__assign({}, labelInfo), { value: "" + standardSymbol + standard + standardUnit, enValue: '' });
    }
    else if (isDate(propertyItem)) {
        return __assign(__assign({}, labelInfo), { value: moment(valueItem).format('YYYY-MM-DD'), enValue: '' });
    }
    else if (isList(propertyItem)) {
        return __assign(__assign({}, labelInfo), { value: valueItem.join(',') || '', enValue: '' });
    }
    if (isText(propertyItem)) {
        return __assign(__assign({}, labelInfo), { value: valueItem, enValue: '' });
    }
    return __assign(__assign({}, labelInfo), { value: valueItem, enValue: '' });
};
export var isAvailableBaseField = function (field) {
    return availableBaseFields.some(function (_a) {
        var _b = __read(_a, 1), key = _b[0];
        return key === field;
    });
};
